module.exports = __webpack_public_path__ + "img/IMG_8059.59487bb6.jpg";